import React, { useEffect } from "react";
import { Icons, Box, Stack } from "@curves/ui-base";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import useSwitch from "@util/hook/useSwitch";

const HealthDeclarationTip = ({ memberID, isShow: isShowProps = false, children }) => {
	const { getMemberProfileHealthDeclarationApi } = useMemberProfileApi();
	const { isOn: isShow, handleTurnOn, handleTurnOff } = useSwitch(isShowProps);

	const doGetMemberProfileHealthDeclarationApi = async memberID => {
		const resp = await getMemberProfileHealthDeclarationApi(memberID);
		if (resp) {
			const { hasNewHealthDeclaration } = resp || {};

			if (!hasNewHealthDeclaration) {
				handleTurnOn();
			} else {
				handleTurnOff();
			}
		}
	};

	useEffect(
		() => {
			if (memberID) {
				doGetMemberProfileHealthDeclarationApi(memberID);
			}
		},
		// eslint-disable-next-line
		[memberID]
	);

	return (
		<Box className={"health-declaration-tip"}>
			{isShow && (
				<Stack className={"health-declaration-tip__text"} alignItems={"center"}>
					<Icons.ErrorOutline className={"mr-1"} htmlColor={"#ef5350"} />
					<Box className={"mb-1"} component={"span"}>
						還沒有填寫新版的健康申告書
					</Box>
				</Stack>
			)}
			{children}
		</Box>
	);
};

export default HealthDeclarationTip;
